module.exports = __webpack_public_path__ + "static/UnclickOutPatientMedical-e0456dd0eae94627c7b98e388bb4213c.png";